import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { CASH_APP } from "./apiRoutes";

const mutateAddPostCashApp = async ({
  communityId,
  documentId,
}: {
  communityId: string;
  documentId: string;
}) => {
  return await axiosAuth.post(`${CASH_APP(communityId)}/${documentId}/post`);
};

const useAddPostCashAppMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      documentId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPostCashApp,
    ...queryParams,
  });

export default useAddPostCashAppMutation;
